import { render, staticRenderFns } from "./OntUpgradeStatus.vue?vue&type=template&id=7b088886&"
import script from "./OntUpgradeStatus.vue?vue&type=script&lang=js&"
export * from "./OntUpgradeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports